export default "/images/38f9eab9868eefe8058c5d828fbf9530.avif";